import Vue from "vue";
import NotificationMessageRepository from "@/repositories/NotificationMessageRepository";
import _ from "lodash";
import store from "@/store";
import moment from "moment";

export interface NotificationMessage {
    uuid: string;
    subject: string;
    body: string|null;
    link: string|null;
    type: string;
    seenAt: null;
    deletedAt: null;
    createdAt: string;
}

export default {
    state: {
        notificationMessages: [],
    },
    mutations: {
        setNotificationMessages: (state: any, notificationMessages: NotificationMessage[]) => {
            Vue.set(state, "notificationMessages", notificationMessages);
        },
        updateNotificationMessage: (state: any, message: NotificationMessage) => {
            const messageIndex = state.notificationMessages.findIndex(
                (item: NotificationMessage) => item.uuid === message.uuid
            );
            if (messageIndex >= 0) {
                Vue.set(state.notificationMessages, messageIndex, message);
            }
        },
        deleteNotificationMessage: (state: any, uuid: string) => {
            const messageIndex = state.notificationMessages.findIndex(
                (item: NotificationMessage) => item.uuid === uuid
            );
            if (messageIndex >= 0) {
                Vue.delete(state.notificationMessages, messageIndex);
            }
        },
    },
    getters: {
        getNotificationMessages: (state: any): NotificationMessage[] => {
            return state.notificationMessages;
        },
    },
    actions: {
        loadNotificationMessages: ({ commit }: any) => {
            return new Promise((resolve: (value: object) => void, reject: (value: object) => void) => {
                NotificationMessageRepository.list({
                    uuid: _.get(store, "getters.getCurrentUser.uuid", "")
                }).then((data: any) => {
                    commit("setNotificationMessages", data);
                    resolve(data);
                }).catch((reason: any) => {
                    reject(reason);
                });
            });
        },
        markNotificationMessageAsRead: ({ commit }: any, uuid: string) => {
            return new Promise((resolve: (value: object) => void, reject: (value: object) => void) => {
                NotificationMessageRepository.save({
                    uuid,
                    seenAt: moment().format("YYYY-MM-DD HH:mm:ss"),
                }).then((data: any) => {
                    commit("updateNotificationMessage", data);
                    resolve(data);
                }).catch((reason: any) => {
                    reject(reason);
                });
            });
        },
        deleteNotificationMessage: ({ commit }: any, uuid: string) => {
            return new Promise((resolve: () => void, reject: (value: object) => void) => {
                NotificationMessageRepository.save({
                    uuid,
                    deletedAt: moment().format("YYYY-MM-DD HH:mm:ss"),
                }).then((data: any) => {
                    commit("deleteNotificationMessage", uuid);
                    resolve();
                }).catch((reason: any) => {
                    reject(reason);
                });
            });
        },
        deleteAllMessages: ({ commit, dispatch }: any, seenOnly: boolean = false) => {
            return new Promise((resolve: () => void, reject: (value: object) => void) => {
                NotificationMessageRepository.deleteAll(seenOnly).then((data: any) => {
                    dispatch("loadNotificationMessages").then(() => {
                        resolve();
                    });
                }).catch((reason: any) => {
                    reject(reason);
                });
            });
        },
        seenAllMessages: ({ commit, dispatch }: any) => {
            return new Promise((resolve: () => void, reject: (value: object) => void) => {
                NotificationMessageRepository.seenAll().then((data: any) => {
                    dispatch("loadNotificationMessages").then(() => {
                        resolve();
                    });
                }).catch((reason: any) => {
                    reject(reason);
                });
            });
        },
    },
};
